/* ====================================================================
   Oduree - Kraskaart-cadeaus (Alia)
   ====================================================================
   De Alia-kraskaart geeft een kortingscode. Een code kan in Shopify zelf
   geen product toevoegen, dus dit script houdt de winkelwagen in de pas,
   per cadeau:

     SLEUTELHANGER  code + betaald autoparfum + geen abonnement
                    -> Alcantara Sleutelhanger (1 stuk) automatisch in de cart
     SAMPLE         code + betaalde aankoop (welk product ook) + geen abonnement
                    -> één Autoparfum Spray Sample, willekeurige geur die op
                       voorraad is en liefst nog niet in de cart zit,
                       automatisch in de cart
     anders         -> door ons toegevoegd cadeau weer weghalen

   Het op €0 zetten doen de Shopify Functions "kraskaart-keychain" en
   "kraskaart-sample" in de app oduree-cadeaus (gekoppeld aan dezelfde codes);
   de drawer toont de regel als GRATIS zodra hij ook echt €0 is, anders als
   gewone regel met prijs (zie sections/cart-drawer.liquid). Producten die de
   klant zelf toevoegde (zonder onze property) blijven met rust.

   Eigen properties per cadeau (bewust GEEN _oduree_gift: de drawer ruimt
   _oduree_gift-regels met "sleutelhanger" op als oud bundelcadeau, en
   assets/custom.js ruimt losse samples op tenzij ze onze property dragen).

   Het live drawer-script is assets/cart-drawer.js (geladen vanuit
   sections/cart-drawer.liquid, vóór cart-drawer-no-paraplu.js); dat script
   roept na een kortingscode uit het formulier window.OdureeKraskaart.sync() aan.
   ==================================================================== */
(function () {
  "use strict";

  if (window.OdureeKraskaart && window.OdureeKraskaart._initialized) return;

  var AUTOPARFUM_HANDLES = ["autoparfum-spray", "autoparfum-hanger"];
  var SPRAY_HANDLE = "autoparfum-spray";
  // Instant Crush To-Go: de automatische 2+1/3+2-bundels combineren niet met
  // productkortingen. Shopify zou dan de "beste" korting kiezen en de klant
  // stilzwijgend zijn gratis spray(s) afpakken voor het cadeau. Zit dit
  // artikel 2x of vaker in de cart, dan geen cadeau (de functies doen
  // hetzelfde, zodat drawer en checkout gelijk blijven).
  var INSTANT_CRUSH_VARIANT_ID = 54608657842522;
  var INSTANT_CRUSH_BUNDLE_QTY = 2;

  var CADEAUS = [
    {
      key: "sleutelhanger",
      code: "SLEUTELHANGER",
      marker: "_oduree_kraskaart",
      variantId: 53387064050010,
      vereist: "autoparfum",
    },
    {
      key: "sample",
      code: "SAMPLE",
      marker: "_oduree_kraskaart_sample",
      variantId: null, // willekeurige Sample-variant van Autoparfum Spray
      vereist: "aankoop",
    },
  ];
  var MARKERS = CADEAUS.map(function (c) { return c.marker; });

  var busy = false;
  var pending = false;
  var timer = null;
  // Aanroepers die tijdens een lopende sync binnenkomen (bijv. de coupon-
  // handler van de drawer) krijgen een promise die pas resolvet als de
  // pending run klaar is; anders beoordelen ze /cart.js te vroeg.
  var wachtenden = [];
  // Per cadeau: handtekening van de cart waarbij het toevoegen mislukte
  // (Shopify zette de regel niet op €0: code ongeldig, verlopen of niet
  // toepasbaar; of de variant is niet leverbaar). Zolang de cart niet
  // wezenlijk verandert proberen we het niet opnieuw, anders zou elke
  // refresh het cadeau toevoegen en weer weghalen.
  var failedSignature = {};
  var sampleVariantsCache = null;
  // Aantal keer dat de sample deze pagina van geur wisselde (zie syncCadeau);
  // de grens voorkomt dat wisselen ooit een lus wordt.
  var MAX_WISSELS = 3;
  var wissels = 0;

  function prop(item, name) {
    var props = (item && item.properties) || {};
    return Object.prototype.hasOwnProperty.call(props, name) ? String(props[name] || "") : "";
  }

  function itemHandle(item) {
    var handle = String((item && item.handle) || "").toLowerCase();
    if (handle) return handle;
    var m = String((item && item.url) || "").toLowerCase().match(/\/products\/([^/?#]+)/);
    return m ? m[1] : "";
  }

  function isAutoparfum(item) {
    if (AUTOPARFUM_HANDLES.indexOf(itemHandle(item)) !== -1) return true;
    return /^autoparfum/i.test(String((item && item.product_type) || ""));
  }

  function isSampleItem(item) {
    return itemHandle(item) === SPRAY_HANDLE && /sample/i.test(String((item && item.variant_title) || ""));
  }

  // Geur van een cartregel of variant: SKU na het eerste streepje, in kleine
  // letters zonder spaties en tekens (APS5-Savage en APH-Savage -> "savage");
  // zonder SKU de eerste optiewaarde.
  function geurVan(x) {
    var sku = String((x && x.sku) || "");
    var opties = (x && (x.options || x.variant_options)) || [];
    var bron = sku ? sku.slice(sku.indexOf("-") + 1) : String(opties[0] || "");
    return bron.toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function isAnyGiftLine(item) {
    return MARKERS.some(function (marker) { return prop(item, marker).toLowerCase() === "true"; });
  }

  function hasCode(cart, code) {
    var codes = (cart && cart.discount_codes) || [];
    return codes.some(function (c) {
      return c && String(c.code || "").toUpperCase() === code;
    });
  }

  function hasSubscription(cart) {
    var items = (cart && cart.items) || [];
    var attrs = (cart && cart.attributes) || {};
    if (String(attrs._oduree_box || "") === "true") return true;
    return items.some(function (it) {
      return !!it.selling_plan_allocation || prop(it, "_oduree_wcg") === "true";
    });
  }

  function hasInstantCrushBundle(cart) {
    return ((cart && cart.items) || []).some(function (it) {
      return Number(it.variant_id) === INSTANT_CRUSH_VARIANT_ID && (it.quantity || 0) >= INSTANT_CRUSH_BUNDLE_QTY;
    });
  }

  function isPaidLine(it) {
    if (isAnyGiftLine(it)) return false;
    if (prop(it, "_oduree_punten")) return false;
    return (it.final_line_price || 0) > 0;
  }

  function hasPaidAutoparfum(cart) {
    return ((cart && cart.items) || []).some(function (it) { return isAutoparfum(it) && isPaidLine(it); });
  }

  // "Bij elke bestelling": welk betaald product ook, behalve losse samples
  // (die zijn niet los te koop) en andere cadeaus.
  function hasPaidPurchase(cart) {
    return ((cart && cart.items) || []).some(function (it) { return !isSampleItem(it) && isPaidLine(it); });
  }

  function signature(cart) {
    var codes = ((cart && cart.discount_codes) || []).map(function (c) { return String(c.code || "").toUpperCase(); }).sort();
    var lines = ((cart && cart.items) || [])
      .filter(function (it) { return !isAnyGiftLine(it); })
      .map(function (it) { return it.key + ":" + it.quantity; })
      .sort();
    return codes.join(",") + "|" + lines.join(",");
  }

  function getCart() {
    // Gedeelde lezer uit layout/theme.liquid (één verzoek voor alle scripts, na elke wijziging vers).
    if (window.OdureeCart && typeof window.OdureeCart.get === "function") return window.OdureeCart.get();
    return fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) {
        var err = new Error("kraskaart: " + url + " " + r.status);
        err.status = r.status;
        throw err;
      }
      return r.json();
    });
  }

  function removeLines(lines) {
    var chain = Promise.resolve();
    lines.forEach(function (line) {
      chain = chain.then(function () {
        return post("/cart/change.js", { id: line.key, quantity: 0 });
      });
    });
    return chain;
  }

  function refreshDrawer() {
    if (window.CartDrawer && typeof window.CartDrawer.refresh === "function") {
      return window.CartDrawer.refresh();
    }
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    return Promise.resolve();
  }

  // Willekeurige Sample-variant van Autoparfum Spray die op voorraad is, bij
  // voorkeur in een geur die nog niet in de cart zit (een sample hoort een
  // nieuwe geur te laten ontdekken). alleenNieuw: zonder nieuwe geur null.
  // Eén keer per pagina ophalen; de keuze zelf is per toevoeging willekeurig.
  function pickSampleVariant(uitsluiten, geuren, alleenNieuw) {
    var load = sampleVariantsCache
      ? Promise.resolve(sampleVariantsCache)
      : fetch("/products/" + SPRAY_HANDLE + ".js", { cache: "no-store", headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            var variants = ((product && product.variants) || []).filter(function (v) {
              return v && v.available && /sample/i.test(String(v.title || ""));
            });
            // Alleen cachen bij een geslaagd, niet-leeg antwoord; een throttle
            // of storing mag de rest van de pagina niet blokkeren.
            if (product && variants.length) sampleVariantsCache = variants;
            return variants;
          })
          .catch(function () { return []; });
    return load.then(function (variants) {
      var keuze = (variants || []).filter(function (v) { return (uitsluiten || []).indexOf(v.id) === -1; });
      var nieuw = keuze.filter(function (v) { return (geuren || []).indexOf(geurVan(v)) === -1; });
      if (nieuw.length || alleenNieuw) keuze = nieuw;
      if (!keuze.length) return null;
      return keuze[Math.floor(Math.random() * keuze.length)].id;
    });
  }

  function wanted(cadeau, cart) {
    if (!hasCode(cart, cadeau.code)) return false;
    if (hasSubscription(cart) || hasInstantCrushBundle(cart)) return false;
    return cadeau.vereist === "autoparfum" ? hasPaidAutoparfum(cart) : hasPaidPurchase(cart);
  }

  // Eén cadeau in de pas brengen; geeft een actie-string terug (of null).
  function syncCadeau(cadeau, cart) {
    var isMine = function (it) { return prop(it, cadeau.marker).toLowerCase() === "true"; };
    var mine = cart.items.filter(isMine);
    // Geuren in de cart: alle regels behalve deze cadeauregel zelf.
    var geuren = cart.items.filter(function (it) { return !isMine(it); }).map(geurVan).filter(Boolean);
    var properties = {};
    properties[cadeau.marker] = "true";

    if (!wanted(cadeau, cart)) {
      if (!mine.length) return Promise.resolve(null);
      return removeLines(mine).then(function () { return "removed"; });
    }

    if (mine.length) {
      // Precies één exemplaar, aantal 1: extra regels of hogere aantallen
      // zouden betaalde cadeaus worden (de functie maakt er één gratis).
      // Eerst normaliseren; de prijscheck volgt in de volgende sync, want
      // /cart.js herrekent pas daarna.
      var fixes = Promise.resolve();
      var changed = false;
      mine.forEach(function (line, idx) {
        var target = idx === 0 ? 1 : 0;
        if (line.quantity !== target) {
          changed = true;
          fixes = fixes.then(function () {
            return post("/cart/change.js", { id: line.key, quantity: target });
          });
        }
      });
      if (changed) return fixes.then(function () { return "normalized"; });

      // Door ons toegevoegd, maar Shopify rekent hem niet op €0 (code
      // ongeldig, verlopen of al gebruikt): weer weghalen, anders staat er
      // ongevraagd een betaald product in de cart.
      if ((mine[0].final_line_price || 0) > 0) {
        failedSignature[cadeau.key] = signature(cart);
        return removeLines(mine).then(function () { return "removed-unpaid"; });
      }
      failedSignature[cadeau.key] = "";

      // Sample in een geur die de klant er zelf bij zette: omwisselen naar een
      // leverbare geur die nog niet in de cart zit (weghalen en opnieuw
      // toevoegen). Geen nieuwe geur of al MAX_WISSELS keer: laten staan.
      if (!cadeau.variantId && wissels < MAX_WISSELS && geuren.indexOf(geurVan(mine[0])) !== -1) {
        return pickSampleVariant([], geuren, true).then(function (variantId) {
          if (!variantId) return null;
          wissels++;
          return removeLines(mine)
            .then(function () {
              // Mislukt het toevoegen, dan de oude sample terugzetten en deze
              // pagina niet meer wisselen; mislukt ook dat, dan probeert de
              // volgende sync het.
              return post("/cart/add.js", { items: [{ id: variantId, quantity: 1, properties: properties }] })
                .catch(function () {
                  sampleVariantsCache = null;
                  wissels = MAX_WISSELS;
                  return post("/cart/add.js", { items: [{ id: mine[0].variant_id, quantity: 1, properties: properties }] })
                    .catch(function () {});
                });
            })
            .then(function () { return "swapped"; });
        });
      }
      return Promise.resolve(null);
    }

    if (failedSignature[cadeau.key] && failedSignature[cadeau.key] === signature(cart)) return Promise.resolve(null);

    var toevoegen = function (uitsluiten) {
      var variantPromise = cadeau.variantId ? Promise.resolve(cadeau.variantId) : pickSampleVariant(uitsluiten, geuren);
      return variantPromise.then(function (variantId) {
        if (!variantId) {
          failedSignature[cadeau.key] = signature(cart);
          console.warn("[OdureeKraskaart] geen leverbare variant voor", cadeau.key);
          return null;
        }
        return post("/cart/add.js", { items: [{ id: variantId, quantity: 1, properties: properties }] })
          .catch(function (err) {
            // Net uitverkocht (422) bij een willekeurige sample: één keer een
            // andere geur proberen. Anders (4xx): niet bij elk cart-event
            // opnieuw proberen; de code blijft gewoon op de cart staan.
            if (err && err.status === 422 && !cadeau.variantId && !(uitsluiten && uitsluiten.length)) {
              sampleVariantsCache = null;
              return toevoegen([variantId]);
            }
            if (err && err.status && err.status < 500) {
              failedSignature[cadeau.key] = signature(cart);
              console.warn("[OdureeKraskaart] cadeau niet toe te voegen", cadeau.key, err.status);
              return null;
            }
            throw err;
          });
      });
    };
    return toevoegen([])
        .then(function (res) {
          if (res === null) return null;
          return getCart().then(function (after) {
            var added = ((after && after.items) || []).filter(isMine);
            if (!added.length) return null;
            // Meer dan één regel of aantal > 1 (bijv. twee tabbladen tegelijk):
            // eerst normaliseren, de prijscheck volgt in de volgende sync.
            if (added.length > 1 || added[0].quantity !== 1) return "added";
            if ((added[0].final_line_price || 0) === 0) return "added";
            failedSignature[cadeau.key] = signature(after);
            return removeLines(added).then(function () { return "added-then-removed"; });
          });
        });
  }

  function sync() {
    if (busy) {
      pending = true;
      return new Promise(function (resolve) { wachtenden.push(resolve); });
    }
    busy = true;
    var acties = [];
    // Cadeaus na elkaar, met tussendoor een verse cart: elke mutatie verandert
    // regelprijzen en keys, en twee mutaties tegelijk geven races.
    var chain = Promise.resolve();
    CADEAUS.forEach(function (cadeau) {
      chain = chain.then(function () {
        return getCart().then(function (cart) {
          if (!cart || !cart.items) return null;
          return syncCadeau(cadeau, cart);
        }).then(function (actie) { if (actie) acties.push(actie); });
      });
    });
    return chain
      .then(function () {
        busy = false;
        if (acties.length) return refreshDrawer();
      })
      .catch(function (err) {
        busy = false;
        console.warn("[OdureeKraskaart] sync error", err);
      })
      .then(function () {
        if (pending) {
          pending = false;
          return sync();
        }
        var klaar = wachtenden;
        wachtenden = [];
        klaar.forEach(function (resolve) { resolve(); });
      });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay || 250);
  }

  function bind() {
    // Na elke drawer-refresh (qty, verwijderen, code toepassen of wissen).
    document.addEventListener("cart:updated", function () { schedule(150); });
    // Native add-to-cart flows die buiten de drawer om gaan.
    document.documentElement.addEventListener("variant:add", function () { schedule(600); });
    document.documentElement.addEventListener("cart:change", function () { schedule(600); });
    // Kortingscode via het drawer-formulier: de drawer roept na het toepassen
    // zelf window.OdureeKraskaart.sync() aan (zie cart-drawer.js).
    // Terug op de pagina (bfcache) of eerste load: cart kan intussen gewijzigd zijn.
    window.addEventListener("pageshow", function () { schedule(400); });
    schedule(900);
  }

  window.OdureeKraskaart = { _initialized: true, sync: sync, cadeaus: CADEAUS };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
